import { useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { uploadProductsExcel } from '../../../../api/Product';
import { Waiting } from '../../../../components/Waiting/Waiting';
import { FileDropzone } from '../../../../components/FileDropzone/FileDropzone';
import { sharedStyles } from '../../../../utils/Style';

interface BulkPriceUploadDialogProps {
  open: boolean;
  onClose: () => void;
  onUpload: () => void;
}

export const BulkPriceUploadDialog = (props: BulkPriceUploadDialogProps) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<File | undefined>(undefined);

  const handleUpload = () => {
    if (!file) return;

    setLoading(true);
    uploadProductsExcel(file)
      .then(() => {
        toast.success('Fiyat listesi başarıyla yüklendi');
        props.onUpload();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <Waiting open={loading} />
      <DialogTitle>Toplu Fiyat Güncelle</DialogTitle>

      <DialogContent>
        <FileDropzone onChange={setFile} sx={{ width: 400 }} />
      </DialogContent>

      <DialogActions>
        <Button
          variant='contained'
          color='inherit'
          onClick={props.onClose}
          sx={sharedStyles.buttonText}
        >
          İptal
        </Button>

        <Button
          variant='contained'
          color='primary'
          disabled={!file}
          onClick={handleUpload}
          sx={sharedStyles.buttonText}
        >
          Yükle
        </Button>
      </DialogActions>
    </Dialog>
  );
};
